import React, { useState } from 'react'
import { Panel, Button, Input, ControlLabel, Message, Radio, RadioGroup } from 'rsuite'
import { useHistory } from 'react-router-dom'
import { useForm, Controller } from 'react-hook-form'
import { startLoading, doneLoading } from '../../../utils/loading'
import { isValidators, requiredFiled } from '../../../utils/ValidatorUtils'
import ErrorMessage from '../../../components/message/errorMessage/ErrorMessage'
import ConfirmWidget from '../../confirm/ConfirmWidget'
import pathname from '../../../constants/pathname'
import { updateWidthdrawRequestSecureApprove } from '../../../redux/actions/withdrawRequest'
import OverlayLoader from '../../../components/OverlayLoader/OverlayLoader'

export default function ApproveWithdrawWidget(props) {
  const { showCommandButton, schema, disabled } = props
  const [isLoading, setIsLoading] = useState(false)
  const [memo, setMemo] = useState('')
  const [showConfirm, setShowConfirm] = useState(false)
  const [approveType, setApproveType] = useState()
  const [approveError, setApproveError] = useState('')

  const { register, handleSubmit, errors, control, setValue, setError, clearErrors } = useForm()

  const projectId = sessionStorage.getItem('projectId')
  const history = useHistory()

  const handleCallService = async () => {
    let request = {
      value: memo,
      isApproved: approveType == 1 ? true : false,
    }
    // console.log('req555522 => ', request)
    setIsLoading(true)
    startLoading()
    setApproveError('')
    try {
      const response = await updateWidthdrawRequestSecureApprove(
        projectId,
        schema.requestId,
        request
      )
      //console.log('response', response)
      if (response.isSuccess) {
        if (response.isSecureApproved) {
          doneLoading()
          window.location.href = response.secureApproved.secureApprovalUri
        } else {
          //success jump to new page
          setShowConfirm(false)
          setApproveError('')
          doneLoading()
          setIsLoading(false)
          return history.push(`${pathname.proposal.overview.overviewCoworker}`)
        }
      } else {
        setShowConfirm(false)
        setApproveError(response.message)
      }
    } catch (e) {
      setShowConfirm(false)
      if (e?.response?.data?.errorMessage) {
        setApproveError(e.response.data.errorMessage)
      } else {
        let errorMessage = ''
        e?.response?.data?.errors?.message?.forEach((element) => {
          errorMessage = errorMessage.concat(element)
        })
        setApproveError(errorMessage)
      }
      // setApproveError(schema.buttonText + `ไม่สำเร็จ`)
    }
    doneLoading()
    setIsLoading(false)
  }

  const onSubmit = (data) => {
    //console.log('data', data)
    setMemo(data.note)
    if (data.approveType) {
      setApproveType(data.approveType)
    }
    setShowConfirm(true)
  }

  return (
    <div>
      {isLoading && <OverlayLoader />}

      <Panel
        header={schema?.header}
        collapsible
        defaultExpanded
        bordered
        shaded
        style={{ marginBottom: 10 }}
      >
        {schema?.approveComments?.length > 0 &&
          schema?.approveComments?.map((item, index) => {
            return (
              <Message
                key={index}
                type={'info'}
                description={`${item.label || 'ไม่ระบุ'} : ${item.value || 'ไม่ระบุ'}`}
              />
            )
          })}

        {schema?.warningMessage && (
          <Message showIcon type={'warning'} description={schema?.warningMessage} />
        )}

        <ControlLabel>{requiredFiled(schema.note.validators, schema.note.label)}</ControlLabel>
        <ErrorMessage error={errors[schema.note.name]} />
        <br />
        <Input
          name={schema.note.name}
          inputRef={register(isValidators(schema.note.validators))}
          rows={3}
          placeholder={schema.note.label}
          componentClass="textarea"
          defaultValue={schema.note.value}
          disabled={disabled}
        />

        {schema.approveType && (
          <>
            <br />
            <Controller
              key={schema.approveType.name}
              name={schema.approveType.name}
              control={control}
              rules={isValidators(schema.approveType.validators)}
              defaultValue={schema.approveType.value}
              render={(props) => {
                return (
                  <RadioGroup
                    value={props.value}
                    onChange={(value) => {
                      props.onChange(value)
                    }}
                  >
                    {schema.approveType?.options?.map((item) => {
                      return (
                        <Radio value={item.value} disabled={disabled}>
                          {item.label}{' '}
                        </Radio>
                      )
                    })}
                  </RadioGroup>
                )
              }}
            />
          </>
        )}

        {showCommandButton && (
          <>
            <hr />
            {approveError && <Message showIcon type="error" description={approveError} />}

            <Button
              style={{ width: 'auto' }}
              // appearance="ghost"
              color="rgb(45, 168, 136)"
              appearance="primary"
              onClick={handleSubmit(onSubmit)}
              disabled={disabled}
            >
              {schema.buttonText}
            </Button>
          </>
        )}
      </Panel>

      <ConfirmWidget
        title={`ยืนยันการ${schema.buttonText}`}
        show={showConfirm}
        detail={`กรุณายืนยันการ${schema.buttonText}`}
        onCancle={() => setShowConfirm(false)}
        onConfirm={() => handleCallService()}
      />
    </div>
  )
}
